export default __webpack_public_path__ + "static/media/material5.aed72b82.png";